<owc-card class="one-card-flat nd-recipients-table">
  <owc-table>
    <owc-table-header sticky>
      <owc-table-header-cell>
        <owc-checkbox style="height: 25px;" [checked]="isAllSelected()" [indeterminate]="isIndeterminate()"
          (change)="masterToggle()">
        </owc-checkbox>
      </owc-table-header-cell>

      @for(column of selectedRecepientColumns; track column.value) {
      <owc-table-header-cell sortable [align]="'left'" [title]="column.key" (sortOrderChange)="OnSort(column.value, $event.detail)">
        {{ column.key }}
      </owc-table-header-cell>
      }


      <owc-table-header-cell></owc-table-header-cell>
    </owc-table-header>

    <owc-table-body>
      @if(dataSource?.length > 0) {
      @for(row of dataSource; track $index) {
      <owc-table-row (click)="gotoAccountDetailsPage(row)" style="cursor: pointer;">
        <owc-table-simple-cell>
          <owc-checkbox (click)="$event.stopPropagation()" (change)="toggleSelection(row)" [checked]="isSelected(row)"
            [disabled]="row.disabled">
          </owc-checkbox>
        </owc-table-simple-cell>


        @for(column of selectedRecepientColumns; track column.value) {
        <owc-table-simple-cell [title]="row[column.value]" style="cursor: pointer;">

          <div class="truncate-text" *ngIf="column.value != 'AccountStatus'; else displayStatusChip">


            <div class="truncate-text"
              *ngIf="column.value != 'AccountDeliveryFailures'; else displayAccountDeliveryFailures">

              <span *ngIf="column.value == 'AccountId' || column.value == 'AccountName'; else displayDateField">
                {{ row[column.value] }}
              </span>


              <ng-template #displayDateField>
                {{ appUtils.formatDateWithTime(row[column.value]) }}
              </ng-template>

            </div>


            <ng-template #displayAccountDeliveryFailures>
              <span *ngIf="row.AccountDeliveryFailures === 'True'"
                style="display:flex;justify-content:center;align-items:center">
                <owc-chip style="background-color: #ffb6c1;padding:8px;border-radius:16px;display:inline-block; cursor: pointer;"
                  [title]="row.AccountDeliveryFailures" class="list-source-chip truncate-text">
                  Yes
                </owc-chip>
              </span>
            </ng-template>

          </div>


          <ng-template #displayStatusChip>
            <owc-chip [ngClass]="appUtils.getColor(row.AccountStatus)" [title]="row.AccountStatus" class="notification-list-source-chip" style="cursor: pointer;">
              <span class="ellipsis">
                {{ displayStatus(row.AccountStatus) }}
              </span>
            </owc-chip>
          </ng-template>

        </owc-table-simple-cell>
        }

        <owc-table-simple-cell style="padding: 0px; display: flex; align-items: center; justify-content: center; cursor: pointer;">
          <owc-icon name="chevron_right" family="outlined" (click)="$event.stopPropagation(); gotoAccountDetailsPage(row)" style="cursor: pointer;"></owc-icon>
        </owc-table-simple-cell>

      </owc-table-row>
      }
      } @else {
      <!-- No Data Row -->
      <owc-table-row>
        <owc-table-simple-cell [attr.colspan]="selectedRecepientColumns.length + 2" style="text-align: center; padding: 48px 24px;">
          <div class="no-data-message">
            @if(contactDetails?.length < 1) {
              No data available.
            } @else if(dataSource?.length < 1) {
              No data available with given filter or search criteria.
            }
          </div>
        </owc-table-simple-cell>
      </owc-table-row>
      }
    </owc-table-body>

    <!-- Footer -->
 <owc-footer>
      <div style="display: flex; padding: 10px;">
        <div class="left-button">
          <owc-button color="primary" [disabled]="selectedRows.size < 1" (click)="downloadReport()" style="margin-right: 10px;">Download
            report</owc-button>
          <owc-button mat-stroked-button one-secondary-button (click)="viewAuditTrail()">Audit trail</owc-button>
        </div>
        <owc-modal-dialog [(ngModel)]="visibleDownload" size="small">
          <dl-file-format-dialog (formatSelected)="onFileFormatSelected($event)"></dl-file-format-dialog>
        </owc-modal-dialog>
        <owc-modal-dialog [(ngModel)]="visibleAuditTrail" size="large" >
          <dl-notification-audit-trail [inputData]="inputData"
            (closed)="visibleAuditTrail = false"></dl-notification-audit-trail>
        </owc-modal-dialog>

        <div class="right-button" *ngIf="userPermission.SendNotification">
          <owc-button [disabled]="isAddRecipientDisabled || isSetCom || isSetCancelled || notificationDetails.notificationData.Status === 'Superseded'" mat-stroked-button one-secondary-button (click)="$event.stopPropagation(); openNotificationDetails(notificationDetails.notificationData)">Create New Version</owc-button>
          <owc-button color="primary" [disabled]="selectedRows.size < 1 || notificationDetails.notificationData.Status === 'Superseded' || notificationDetails.notificationData.Status === 'Cancelled' || notificationDetails.notificationData.Status === 'Completed' || notificationDetails.notificationData.Status === 'Complete'" (click)="resendNotification()">Resend to Non-Responders</owc-button>
          <owc-button [disabled]="isAddRecipientDisabled || isSetCom || isSetCancelled || notificationDetails.notificationData.Status === 'Superseded'" mat-stroked-button one-secondary-button (click)="ndAddRecepients()">Add Recipients</owc-button>
        </div>
      </div>
    </owc-footer>
    <!-- Bulk Resend Confirmation Modal -->
    <owc-modal-dialog [(ngModel)]="visibleResendConfirm" size="medium">
      <owc-component-header slot="header" style="font-size: 20px;">Confirm Bulk Resend</owc-component-header>
      <div style="border-top: none; border-bottom: none; padding-left: 20px;">
        <owc-typography variant="body2">
          You are about to resend this notification. Emails will be sent only to contacts in accounts that have not acknowledged or provided feedback. Do you want to proceed?
        </owc-typography>
      </div>
      <owc-component-footer slot="footer">
        <div style="display: flex; justify-content: flex-end; gap: 12px; width: 100%;">
          <owc-button color="primary" (click)="confirmBulkResend()">Confirm Resend</owc-button>
          <owc-button class="cancel-button" (click)="cancelBulkResend()">Cancel</owc-button>
        </div>
      </owc-component-footer>
    </owc-modal-dialog>
    <owc-modal-dialog size="large" style="max-width: 200%; padding:10px;" [(ngModel)]="visibleAddRecipients">
      <dl-notification-add-recipients-template-dialog [data]="data" size="large" 
        (closed)="onAddRecipientsClosed($event)"></dl-notification-add-recipients-template-dialog>
    </owc-modal-dialog>
  </owc-table>
</owc-card>